/**
 * The default application constants should be defined here, which is being used at multiple places
 * @type {string}
 */

export const URLActions: string[] = ["create", "edit", "view"];
